import { Trans, useTranslation } from "next-i18next";
import styles from "./OlympiadFaq.module.scss";
import { UnderlineLink } from "@climate-science/component-library";
import Collapsible from "./Collapsible/Collapsible";

const FaqIds = ['1','2','3x','4', '5x', '6']

const OlympiadFaq = ({
  version
}: {
  version?: 'cso23' | 'cso24'
}) => {
  const {t} = useTranslation('olympiad')
  const prefix = version ? `${version}.` : ''

  return (
    <section className={styles.faqSection}>
      <h2 className={styles.title}>{t('faq')}</h2>
      <div className={styles.faqs}>
        {FaqIds.map((faqId, index) => (
          <Collapsible key={index} title={t(`${prefix}faqs.${faqId}.question`)}>
            <Trans 
              t={t}
              i18nKey={t(`${prefix}faqs.${faqId}.answer`)}
            />
          </Collapsible>
        ))}
      </div>
      <UnderlineLink 
        href='/olympiad-terms'
        className={styles.tc}
      >
        {t('olympiad-tc')}
      </UnderlineLink>
    </section>
  )
}

export default OlympiadFaq